(function(document, window, $) {
    'use strict';


    $(document).ready(function($) {

        if (document.head.querySelector("[name=user]") != undefined)
            var user = document.head.querySelector("[name=user]").content;
        if (document.head.querySelector("[name=pusher]"))
            var pusherkey = document.head.querySelector("[name=pusher]").content;

        var isMobile = window.mobilecheck();


        if (user == undefined || pusherkey == undefined || pusherkey == '') return 0;

        $('html').addClass('pusher');

        var pusher = new Pusher(pusherkey, {
            cluster: 'eu',
            encrypted: true,
            auth: {
                headers: {
                    'X-CSRF-Token': document.head.querySelector("[name=csrf-token]").content
                }
            }
        });

        var channel = pusher.subscribe('private-'+user);
        channel.bind('client-CallPhone', function(data) {
            if (window.mobilecheck()){
                if (data.phone != undefined)
                    window.location.href=data.phone;
                    //window.open(data.phone);
            }
        });

        if (! isMobile){
            $(document).on('click','.btn-caller',function(e){
                e.preventDefault();
                var phone = $(this).attr('href');
                var triggered = channel.trigger('client-CallPhone', { phone: phone });
                var slidepanel= $(this).data('slidepanel');
                if (slidepanel) window.showSlidePanel(slidepanel);
            });
        }

    })
})(document, window, jQuery);